import { memo, useMemo } from 'react';
import { SingleSelect } from '@library';
import withErrorBoundary from '../../core/components/errors/withErrorBoundary';
import useProductFilterCount from '../queries/useProductFilterCount';

const MatchcodeFilter = ({
    value,
    onChange,
}: {
    value: string;
    onChange: (value: string) => void;
}) => {
    const { productFilterValues } = useProductFilterCount({
        filterField: 'PIM_ATT_MATCHCODE',
        filterExceptions: [
            'PIM_ATT_TIRE_WIDTH_MOTO',
            'PIM_ATT_TIRE_HIGHT_MOTO',
            'PIM_ATT_DIAMETER',
            'PIM_ATT_APPLICATION_RANGE',
            'PIM_ATT_ERP_MANUFACTURER',
            'PIM_ATT_LOAD_INDEX',
            'PIM_ATT_SPEEDINDEX',
        ],
    });

    const matchcodeOptions = useMemo(() => {
        return productFilterValues
            .map(matchcode => ({
                label: matchcode.valueLabel || matchcode.value,
                value: matchcode.value,
            }))
            .sort((a, b) => a.label.localeCompare(b.label));
    }, [productFilterValues]);
    return (
        <SingleSelect
            id="match-code"
            value={value}
            onChange={onChange}
            placeholder="z.B. 1805517"
            options={matchcodeOptions}
            disabled={!matchcodeOptions.length}
            searchable
            clearable
            data-test-class="matchCodeFilter"
        />
    );
};

export default memo(withErrorBoundary(MatchcodeFilter));
